import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  facebookIcon,
  googleIcon,
  logo,
  capIcon,
  studentSignupCover,
  CapIconRed,
  ArrowUpRightBlue,
} from "../../constant/imagePath";
import { Button } from "../../stories/Button/Button";
import classes from "./SocialSignupStudentPage.module.css";
import { BeforeLoginHeader } from "../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { useHistory } from "react-router-dom";
import { MobileHeader } from "../../stories/MobileHeader/MobileHeader";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import Colors from "../../stories/assets/Colors";
import Fonts from "../../stories/assets/Fonts";
import { apiHeader, BaseURL } from "../../Config/apiUrl";
import { Post } from "../../Axios/AxiosFunctions";
import { toast } from "react-toastify";

import {
  getAuth,
  createUserWithEmailAndPassword,
  updateProfile,
  GoogleAuthProvider,
  signInWithPopup,
  FacebookAuthProvider,
} from "firebase/auth";
import { async } from "@firebase/util";
import { falsyArray } from "../../util/CustomFunctions";

const SocialSignupStudentPage = (props) => {
  const history = useHistory();

  // variables and states
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const signupUrl = BaseURL("student/signup");

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  // Social Google Signup
  const HandleGoogleSignup = async () => {
    let provider = new GoogleAuthProvider();
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        let token = credential.accessToken;
        let user = result.user;
        const customClaim = await user.getIdTokenResult();
        const role = customClaim?.claims?.role;
        const emailVerification = customClaim?.claims?.email_verified;
        const params = {
          fullName: user?.displayName,
          email: user?.email,
          profilePicture: user?.photoURL,
          ...(falsyArray.includes(user?.phoneNumber) === false &&{"phoneNumber": user?.phoneNumber}),
        };
        if (role === "coach-pending") {
          toast.error(
            "This Email is used by a Coach. Please use another Email."
          );
          return;
        }
        if (role === "student") {
          history.push({
            pathname: `/homepage`,
          });
          // if(emailVerification){
          //   history.push({
          //     pathname: `/homepage`,
          //   });
          // } else {
          //     history.push({
          //       pathname: `/check-your-email`,
          //     });
          //   }
        } else {
          HandleSubmitBackendApi(params, "Google");
        }
      })
      .catch((error) => {
        let errorCode = error.code;
        let errorMessage = error.message;
        let email = error.email;
        let credential = error.credential;
        toast.error(`Error While Google Signup`);
        console.log({ errorCode, errorMessage, email, credential });
      });
  };

  // Social Facebook Signup
  const HandleFacebookSignup = async () => {
    let provider = new FacebookAuthProvider();
    provider.addScope("user_birthday");
    provider.setCustomParameters({
      display: "popup",
    });
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        const credential = FacebookAuthProvider.credentialFromResult(result);
        let token = credential.accessToken;
        let user = result.user;
        const customClaim = await user.getIdTokenResult();
        const role = customClaim?.claims?.role;
        const params = {
          fullName: user?.displayName,
          email: user?.email,
          profilePicture: user?.photoURL,
          ...(falsyArray.includes(user?.phoneNumber) === false &&{"phoneNumber": user?.phoneNumber}),
        };
        if (role === "coach-pending") {
          toast.error(
            "This Email is used by a Coach. Please use another Email."
          );
          return;
        }
        if (role === "student") {
          history.push({
            pathname: `/homepage`,
          });
        } else {
          HandleSubmitBackendApi(params, "Facebook");
        }
      })
      .catch((error) => {
        let errorCode = error.code;
        let errorMessage = error.message;
        let email = error.email;
        let credential = error.credential;
        toast.error(`Error While Facbook Signup`);
      });
  };

  // Submit Backend Api
  const HandleSubmitBackendApi = async (params, provider) => {
    setLoading(true);
    const Header = await apiHeader(false);
    const response = await Post(signupUrl, params, Header);
    setLoading(false);
    if (response !== undefined) {
      toast.success(`${provider} Signup Successful`);
      history.push({
        pathname: `/homepage`,
      });
    }
  };

  return (
    <div className={classes.SocialSignupStudentPage}>
      <div className={`container-fluid ${classes.container}`}>
        {isMobile ? (
          <MobileHeader
            isLogo={true}
            isAvatar={false}
            customStyle={{ padding: "0px " }}
          />
        ) : (
          <BeforeLoginHeader
            onClick={() => {
              history.push({
                pathname: "login",
              });
            }}
            icon={logo}
            text1={"Already have an account?"}
            text2={"Log in"}
            text1Style={{ color: Colors.neutralShadesOfDimGray }}
            goBackOnClick={() => history.goBack()}
          />
        )}

        <div className="row" style={{ height: "100%" }}>
          <div className="col-md-12">
            <div className="row">
              <div
                className={`p-0 col-md-6 ${[
                  classes.imageContainer,
                  classes.innerContainer,
                ].join(" ")}`}
              >
                <img className="img-fluid d-block " src={studentSignupCover} />
              </div>
              <div
                className={`p-5 col-md-6 ${[
                  classes.innerContainer,
                  classes.rightContainer,
                ].join(" ")}`}
              >
                <img
                  className={`img-fluid ${[classes.headingIcon].join(" ")}`}
                  src={isMobile ? CapIconRed : capIcon}
                />
                <span
                  className={`${[classes.headingText].join(" ")}`}
                  style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
                >
                  I'm Student
                </span>
                <Button
                  primary={false}
                  disabled={loading ? true : false}
                  size={"Large"}
                  label={"Sign up with Facebook"}
                  icon={facebookIcon}
                  onClick={() => {
                    HandleFacebookSignup();
                  }}
                />
                <div className="mb-3" />
                <Button
                  primary={false}
                  size={"Large"}
                  label={"Sign up with Google"}
                  icon={googleIcon}
                  disabled={loading ? true : false}
                  onClick={() => {
                    HandleGoogleSignup();
                  }}
                />
                {/* Or Separator */}
                <div className={`${[classes.separatorContainer].join(" ")} `}>
                  <div className={`${[classes.Separator].join(" ")}`} />
                  <div className={`${[classes.orSpan].join(" ")}`}>or</div>
                  <div className={`${[classes.Separator].join(" ")}`} />
                </div>
                <Button
                  primary={false}
                  disabled={false}
                  size={"Large"}
                  label={"Sign up with Email"}
                  onClick={() => {
                    history.push({
                      pathname: "signupStudent",
                    });
                  }}
                />
              </div>
            </div>
          </div>
          {/* Footer */}
          {/* Already have account Login for mobile  */}
          <div className={`col-sm-12 ${classes.footerContainer}`}>
            <div className={classes.alreadyHaveAccountForMobile}>
              <p
                style={{
                  ...Fonts.p2,
                  color: Colors.neutralShadesOfDimGray,
                }}
              >
                Already have an account?
              </p>
              <LinkButtonWithIcon
                primary={true}
                text={"Log in"}
                rightIcon={ArrowUpRightBlue}
                iconStyle={{ margin: "0px" }}
                onClick={() => history.push("/login")}
              />
            </div>
          </div>

          {/*  */}
        </div>
      </div>
    </div>
  );
};

export default SocialSignupStudentPage;
